import { TextField, Modal, Box, Button } from "@mui/material";
import TitreGraphik from "../Typography/TitreGraphik";
import { useTranslation } from "react-i18next";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 300, md: 400 },
  backgroundColor: "white",
  boxShadow: 24,
  p: 4,
};

export default function ModelCaisse({
  open,
  onClose,
  formData,
  submit,
  handleInputChange,
}) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <TitreGraphik>
          {formData.id ? t("Edit Caisse") : t("Add New Caisse")}
        </TitreGraphik>

        <TextField
          fullWidth
          label={t("Nom Caisse")}
          name="nomCaisse"
          value={formData.nomCaisse}
          onChange={handleInputChange}
          margin="normal"
        />
        <TextField
          fullWidth
          label={t("Adress")}
          name="adress"
          value={formData.adress}
          onChange={handleInputChange}
          margin="normal"
        />
        <Button variant="contained" sx={{ marginTop: "20px" }} onClick={submit}>
          {formData.id ? t("Update") : t("Add")}
        </Button>
      </Box>
    </Modal>
  );
}
